var _circle, _rect, _g, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 267,
    viewBox: "0 0 268 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 133.5,
    r: 41.5,
    fill: "#5D9E44"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1139_95999",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 110,
    width: 49,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110.5,
    y: 110,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1139_95999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.5 143.35L122 134.8L125.35 131.5L130.5 136.65L143.7 123.5L147 126.8L130.5 143.35Z",
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 134,
    cy: 133.5,
    r: 86.5,
    stroke: "#9DCE88",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 134,
    cy: 133.5,
    r: 132.5,
    stroke: "#C3E2B4",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesIcon);
export default __webpack_public_path__ + "static/media/succes-icon.90dc89901922e11b588c26f2f38094c0.svg";
export { ForwardRef as ReactComponent };